import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Seo } from "@/components/Seo";
import { EditorialMarquee } from "@/components/Marquee";
import { Categories } from "@/components/Categories";
import { Courses } from "@/components/Courses";
import { Manifesto } from "@/components/Manifesto";
import { About } from "@/components/About";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Home() {
  const [courses, setCourses] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/courses").then((r) => setCourses(r.data)).catch(() => {});
  }, []);

  const onSelectCategory = (key) => {
    setFilter(key);
    const el = document.querySelector("#courses");
    if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
    else if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div data-testid="home-page">
      <Seo
        title="PP Academy — GSEB Tuition, GTU Engineering, Trading & MBA Finance Courses Online"
        description="Online courses by a mechanical engineer & MBA Finance mentor: GSEB Gujarat Board tuition (Classes 1–12), CBSE & ICSE, GTU engineering subjects branch-wise, Zerodha Varsity-style trading modules and VNSGU MBA Finance. Free preview lessons, self-tests and board exam question banks."
        path="/"
      />
      <Header />
      <Hero />
      <EditorialMarquee />
      <Categories courses={courses} onSelect={onSelectCategory} />
      <Courses courses={courses} filter={filter} setFilter={setFilter} />
      <Manifesto />
      <About />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
